import { Maybe } from '@lib/types/Maybe';

export const toNonNullable = <T>(input: Maybe<T>) => input ?? undefined;
